import { render, staticRenderFns } from "./TkTooltips.vue?vue&type=template&id=e2fb4bc6&scoped=true&"
import script from "./TkTooltips.vue?vue&type=script&lang=js&"
export * from "./TkTooltips.vue?vue&type=script&lang=js&"
import style0 from "./TkTooltips.vue?vue&type=style&index=0&id=e2fb4bc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fb4bc6",
  null
  
)

export default component.exports